import './App.css';
import './styles/global.css';
import Header from './Components/header';
import { Routes, Route } from 'react-router-dom'; // ✅ CORRECT
import Home from './pages/Home';
import About from './pages/About';
import Review from './pages/review';
import Menu from './pages/Menu';
import Booking from './pages/Booking';
import ContactUs from './pages/Contact';
import Footer from './Components/Footer';
function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/review" element={<Review />} />
      </Routes>
      <Footer />
 </>
    
  );
}

export default App;
